// 判断是否嵌入其他项目里的
export const inIframe = window.self !== window.top;

// 主应用路由同步
export function parentRouteSame({ to }) {
  if (!inIframe) {
    return;
  }
  // const { parentRouteSamePath, selfRouterPath } = addEventListenerMessage;
  // if (parentRouteSamePath && parentRouteSamePath === selfRouterPath) {
  //   return;
  // }
  // addEventListenerMessage.parentRouteSamePath = to.fullPath;
  window.top.postMessage({
    type: 'parentRouteSame',
    fullPath: to.fullPath,
    // path: to.path,
    // title: to.meta?.title,
  }, '*');
}
export function parentRouter(data) {
  if (!inIframe) {
    return;
  }
  if (parentRouter.prePath === data.path) {
    return;
  }
  parentRouter.prePath = data.path;
  window.top.postMessage({
    type: 'parentRouter',
    path: data.path,
  }, '*');
}

export function parentWindow(data) {
  window.top.postMessage({
    type: 'parentWindow',
    href: data.href,
  }, '*');
}

export function parentModalMaskShow() {
  if (!inIframe) {
    return;
  }
  window.top.postMessage({
    type: 'parentModalMaskShow',
  }, '*');
}
export function parentModalMaskHide() {
  if (!inIframe) {
    return;
  }
  window.top.postMessage({
    type: 'parentModalMaskHide',
  }, '*');
}
export function addEventListenerMessage({
  router,
  // store
}) {
  if (!inIframe) {
    return;
  }
  const iframeMessage = async (e) => {
    const data = e.data || {};
    console.log(data);
    if (data.type === 'selfRouter') {
      // console.log(data);
      // console.log(window.location);
      if (data.path === window.location.pathname) {
        return;
      }

      // const { parentRouteSamePath, selfRouterPath } = addEventListenerMessage;
      // console.log(parentRouteSamePath, selfRouterPath);
      // if (selfRouterPath && parentRouteSamePath === selfRouterPath) {
      //   return;
      // }

      // addEventListenerMessage.selfRouterPath = data.path;
      router.push({
        path: data.path,
        query: data.query,
      });
    }
    if (data.type === 'destroyed') {
      // store.appKey++
    }
    // if (data.type === 'xiaoJingSessionId') {
    //   const item = interceptMap.get(data.type);
    //   if (item) {
    //     // if (!initVpaycenterUserInfo.resolve) {
    //     //   // 防止重复执行
    //     //   return;
    //     // }
    //     await item.intercept({
    //       to: {
    //         query: data,
    //       },
    //     });
    //     initVpaycenterUserInfo.resolve && initVpaycenterUserInfo.resolve();
    //   }
    // }
  };
  window.addEventListener('message', iframeMessage, false);
  window.addEventListener('beforeunload', () => {
    window.top.postMessage({
      type: 'parentBeforeunload',
    }, '*');
  });
}
